module.exports = __webpack_public_path__ + "img/2019-06-24.305b9004.jpg";